import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { OwnerFlowBrand } from "../../../components/OwnerFlowLogo";
import { navLabel } from "../../content/navLabels";
import { AUDIENCE_NAV_IDS, pagePath, type MarketingLang, type MarketingPageId } from "../../content/routes";
import { useMarketingLang } from "../../hooks/useMarketingPage";

const DISCOVER: MarketingPageId[] = ["pricing", "help"];
const COMPANY: MarketingPageId[] = ["about", "contact"];
const LEGAL: MarketingPageId[] = ["privacy", "terms"];

export function MarketingFooter() {
  const { t } = useTranslation();
  const lang = useMarketingLang();

  return (
    <footer className="border-t border-border bg-white">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[minmax(0,1.3fr)_repeat(3,minmax(0,1fr))]">
          <div>
            <Link
              to={pagePath("home", lang)}
              className="flex items-center gap-2.5 text-neutral-900 hover:text-neutral-900"
            >
              <OwnerFlowBrand />
            </Link>
            <p className="mt-4 max-w-xs text-[13px] leading-relaxed text-neutral-500">
              {t(
                "marketing.footer.tagline",
                "Réseau privé de partenaires pour faire circuler votre inventaire locatif — sans marketplace ni commission OwnerFlow sur les réservations.",
              )}
            </p>
          </div>
          <FooterColumn title={t("marketing.footer.product", "Produit")} ids={AUDIENCE_NAV_IDS} lang={lang} t={t} />
          <FooterColumn title={t("marketing.footer.discover", "Découvrir")} ids={DISCOVER} lang={lang} t={t} />
          <div className="space-y-8">
            <FooterColumn title={t("marketing.footer.company", "Entreprise")} ids={COMPANY} lang={lang} t={t} />
            <FooterColumn title={t("marketing.footer.legal", "Légal")} ids={LEGAL} lang={lang} t={t} />
          </div>
        </div>

        <div className="mt-12 flex justify-center border-t border-border pt-8">
          <p className="text-center text-[13px] text-neutral-400">
            © {new Date().getFullYear()} OwnerFlow. {t("landing.footer.rights", "Tous droits réservés.")}
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({
  title,
  ids,
  lang,
  t,
}: {
  title: string;
  ids: MarketingPageId[];
  lang: MarketingLang;
  t: (key: string, fallback: string) => string;
}) {
  return (
    <div>
      <h2 className="text-[13px] font-medium text-neutral-900">{title}</h2>
      <ul className="mt-4 space-y-2.5">
        {ids.map((id) => (
          <li key={id}>
            <Link
              to={pagePath(id, lang)}
              className="text-[13px] text-neutral-500 transition-colors hover:text-neutral-900"
            >
              {navLabel(id, t)}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
